import {LAST_READ_CHAT, NOTIFICATION_SSE} from "./actions/ActionTypes";
import {isEmptyJson} from "../utils/GenericUtils";

export const initChatState = () => {
	return {
		notification_sse: [],
		last_read_chat: null
	}
}

export const CHAT_INITIAL_STATE = {}

export const ChatReducer = (state = CHAT_INITIAL_STATE, action) => {
	//console.log(action);
	switch (action.type) {
		case NOTIFICATION_SSE:
			return {
				...state,
				notification_sse: action.payload,
			}
		case LAST_READ_CHAT:
			//console.log(action, state);
			/**
			 * Dal momento che parto avrò last read chat a null, quindi prendo per buono il payload
			 */
			if (state.last_read_chat === null && action.payload !== null) {
				return {
					...state,
					last_read_chat: action.payload
				}
			}
			let newReadChat = {};
			
			/**
			 * Lo stato è vuoto, uso action.payload
			 */
			if (isEmptyJson(state.last_read_chat)) {
				//{} -- {SISP:123}
				newReadChat = action.payload
			}
			/**
			 * Lo stato non è vuoto, aggiorno prendendo l'id più grande
			 */
			else {
				/**
				 * Assegno newReadChat con lo stato che già avevo, tanto ora aggiorno...
				 */
				newReadChat = {...state.last_read_chat};
				/**
				 * Scorro i miei gruppi
				 */
				Object.entries(state.last_read_chat).forEach(([group, lastMessId]) => {
					/**
					 * Se gruppo è in payload (nel caso in cui abbia già letto qualcosa)
					 * e payload[gruppo] (id dell'ultimo mess che mi da l'evento) è maggiore di quello che avevo aggiorno
					 */
					if (group in action.payload && action.payload[group] >= lastMessId) {
						//console.log(action.payload[group] + " >= " + lastMessId);
						newReadChat[group] = action.payload[group];
					}
					
				})
				
				Object.entries(action.payload).forEach(([actionGroup, actionLastMessId]) => {
					if (!(actionGroup in newReadChat)) {
						newReadChat[actionGroup] = actionLastMessId;
					}
				})
				
				//console.log(newReadChat);
			}
			
			return {
				...state,
				last_read_chat: newReadChat,
			}
		
		default:
			return state;
	}
}
